import { useContext } from 'react';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import { CompanyHotelsContext } from '@app/site/secured/rateshopper/rates/provider/CompanyHotelsProvider';
import CompanyHotelLite from '@app/model/company_hotel/CompanyHotelLite';

export const useCompanyHotels = (): {companyHotels: CompanyHotelLite[], findById: (id: number) => CompanyHotelLite | undefined} => {
	const { companyHotels } = useContext(CompanyHotelsContext);

	const findById = (id: number): CompanyHotelLite | undefined => {
		return companyHotels.find(ch => ch.id == id);
	};

	return {
		companyHotels,
		findById
	};
};